import { StateManager } from 'AppReact';

export default StateManager([
  {
    name: 'detect',
    isRemote: true,
    isSingleton: true,
    defaultValue: [],
    show: (_, { text }) => { return `/api/translate/detect?q=${text}` }
  },
  {
    name: 'translate',
    isRemote: true,
    isSingleton: true,
    defaultValue: [],
    show: (_, { text, target }) => { return `/api/translate?q=${text}&target=${target}` }
  }
])
